import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import Landing from './pages/Landing'
import Entry from './pages/Entry'
import Login from './pages/Login'
import CustomerHome from './pages/customer/CustomerHome'
import ServiceDetail from './pages/customer/ServiceDetail'
import ProviderHome from './pages/provider/ProviderHome'
import ProviderOnboarding from './pages/provider/ProviderOnboarding'
import ServiceOnboarding from './pages/provider/ServiceOnboarding'

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/enter" element={<Entry />} />
        <Route path="/login" element={<Login />} />
        <Route path="/customer" element={<CustomerHome />} />
        <Route path="/services/:id" element={<ServiceDetail />} />
        <Route path="/provider" element={<ProviderHome />} />
        <Route path="/provider/onboarding" element={<ProviderOnboarding />} />
        <Route path="/provider/services/new" element={<ServiceOnboarding />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  )
}

export default App